import React from 'react';
import { useCountdown } from '../../hooks/useCountdown';
const rows = [{
  label: 'Teruggeleverde kWh',
  now: 'Weggestreept tegen verbruik',
  later: '± € 0,05 vergoeding'
}, {
  label: 'Stroom van het net',
  now: '€ 0,27 per kWh',
  later: '€ 0,27 per kWh'
}, {
  label: 'Terugleverkosten',
  now: 'Vaak al in rekening',
  later: 'Tot € 0,12 per kWh'
}];
export function SalderingBand() {
  const c = useCountdown();
  const units = [{
    v: c.days,
    l: 'dagen'
  }, {
    v: c.hours,
    l: 'uur'
  }, {
    v: c.minutes,
    l: 'min'
  }, {
    v: c.seconds,
    l: 'sec'
  }];
  return <section id="saldering" className="scroll-mt-20 bg-forest text-canvas" data-id="element-246" data-mp="26t4x3iwi62la">
      <div className="mx-auto grid max-w-[1440px] gap-14 px-4 py-24 sm:px-6 lg:grid-cols-2 lg:gap-24 lg:px-10 lg:py-32" data-id="element-247" data-mp="2knnqx5ydrxrz">
        <div data-id="element-248" data-mp="1s61xn6omdjvb">
          <h2 className="max-w-2xl text-4xl font-semibold leading-[1.04] tracking-tightest sm:text-5xl lg:text-[56px]" data-id="element-249" data-mp="1s5tkreshyek4">
            Op 1 januari 2027 stopt <span className="text-volt" data-id="element-250" data-mp="1o3yjgaakg16c">de salderingsregeling.</span>
          </h2>
          <p className="mt-5 max-w-md text-lg leading-relaxed text-canvas/70" data-id="element-251" data-mp="2qcbe74b37ucq">
            Wat je overdag teruglevert, levert straks bijna niets meer op. Wat je ’s avonds van het net haalt, blijft
            gewoon duur. Een batterij overbrugt dat verschil.
          </p>
          <div className="mt-10 flex gap-3 sm:gap-4" aria-label="Aftellen tot 1 januari 2027" data-id="element-252" data-mp="352sc4doik24v">
            {units.map(u => <div key={u.l} className="min-w-[72px] rounded-2xl bg-forest-light px-4 py-4 text-center sm:min-w-[92px]" data-id="element-253" data-mp="27fs9qsb8aumi">
                <div className="text-3xl font-semibold tabular-nums text-volt sm:text-4xl" data-id="element-254" data-mp="2cdtqv7p3gjvc">{String(u.v).padStart(2, '0')}</div>
                <div className="mt-1 text-[13px] text-canvas/60" data-id="element-255" data-mp="2mbrepu31kenf">{u.l}</div>
              </div>)}
          </div>
        </div>

        <div className="self-end" data-id="element-256" data-mp="3sqs1paa39mhv">
          <table className="w-full text-left text-[15px]" data-id="element-257" data-mp="3srjuyeg7r84z">
            <caption className="sr-only" data-id="element-258" data-mp="1kqvpg4zdj33">Vergelijking voor en na het einde van de salderingsregeling</caption>
            <thead data-id="element-259" data-mp="1xndjhe33miv6">
              <tr className="border-b border-canvas/15 text-canvas/55" data-id="element-260" data-mp="1xmu15w9jdsgm">
                <th scope="col" className="py-4 pr-4 font-normal" data-id="element-261" data-mp="1soisvpyw3q0i" />
                <th scope="col" className="py-4 pr-4 font-medium" data-id="element-262" data-mp="26p38yedf77qb">Nu</th>
                <th scope="col" className="py-4 font-medium text-volt" data-id="element-263" data-mp="26n8wlog7snxu">Vanaf 2027</th>
              </tr>
            </thead>
            <tbody data-id="element-264" data-mp="1exxhembrmicn">
              {rows.map(r => <tr key={r.label} className="border-b border-canvas/10" data-id="element-265" data-mp="1eyfaja34sggc">
                  <th scope="row" className="py-5 pr-4 font-medium text-canvas" data-id="element-266" data-mp="1a05detxuj5s3">{r.label}</th>
                  <td className="py-5 pr-4 text-canvas/70" data-id="element-267" data-mp="1nriwk6rue1ml">{r.now}</td>
                  <td className="py-5 text-canvas" data-id="element-268" data-mp="1j00vzjtqe325">{r.later}</td>
                </tr>)}
            </tbody>
          </table>
          <p className="mt-5 text-sm text-canvas/50" data-id="element-269" data-mp="v8vg54nsjaru">Tarieven indicatief, gebaseerd op gemiddelde vaste contracten in 2026.</p>
        </div>
      </div>
    </section>;
}